import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      padding: '30px 16px',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  dialogTitle: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },

  dialog: {
    textAlign: 'center',
    direction: 'ltr',
    padding: theme.spacing(2),
    paddingLeft: 20,
    overflowY: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cancelButton: {
    marginLeft: '5px',
  },
  addButton: {
    [theme.breakpoints.up('md')]: {
      transform: 'translate(5px, 31px)',
    },
  },
  isLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '16px 0',
  },
  isError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    margin: '16px 0',
  },
  actionButtons: {
    display: 'flex',
    marginBottom: '16px',
    marginRight: '6px',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 4px',
    },
    [theme.breakpoints.down('sm')]: {},
  },
  buttonAction: {
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flex: '1',
    },
  },
  boxTabel: {
    [theme.breakpoints.down('sm')]: {},
    minHeight: 'auto',
    maxHeight: '500px',
    overflowY: 'auto',
  },
  myCustomTable: {
    direction: 'rtl !important ',
    margin: '0 !important',
    '& th.table-firstRow': {
      fontSize: '0.9rem !important',
      fontWeight: 'bold',
    },
    '& td.table-sectRow': {
      fontSize: '0.8rem !important',
      fontWeight: 'bold',
    },
    '& td.table-RowsValue': {
      fontSize: '0.8rem !important',
      fontWeight: 'bold',
    },
    '& td.table-Rows': {
      fontSize: '0.8rem !important',
    },
    '& th': {
      'border-color': 'rgba(43, 57, 144, 0.5) !important',
    },
    '& td': {
      'border-color': 'rgba(43, 57, 144, 0.5) !important',
    },
  },
}));
